import React, { ReactNode, useState, useEffect, useCallback } from "react";
import styles from "./NavBar.module.scss";
import { AnimatePresence, motion } from "framer-motion";
import classNames from "classnames";
import Logo from "@/components/common/logo/logo";
import Logo2 from "../../../../public/images/Logowhite.png";
import getturftownbutton from "../../../../public/landingimages/getturftownbutton.svg";
import Image from "next/image";
import { useRouter } from "next/router";
import { isAndroid, isIOS } from "react-device-detect";
import Item from "./item";
import GetTurfTownModal from "../GetTurfTownModal";
import Link from "next/link";
import { useAppStore } from "@/providers/app";
import LoggedInNavItem from "../loggedInNavItem";
import Modal from "../modal";
import PrimaryButton from "../primaryButton";
import { ButtonType } from "../primaryButton/types";

export interface NavbarPropType {
  minimal?: boolean;
  leftComponent?: ReactNode;
  noAnimation?: boolean;
}

const NavBar = ({
  minimal = false,
  leftComponent,
  noAnimation,
}: NavbarPropType) => {
  const router = useRouter();
  // const { actions, user } = useContext(AppContext)
  const user = useAppStore((state) => state.user);
  const setLoginModalVisibility = useAppStore(
    (state) => state.setLoginModalVisibility
  );
  const handlelogout = useAppStore((state) => state.logout);
  const [showModal, setModal] = useState<string>("");
  const [showMenu, setShowMenu] = useState<boolean>(false);

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 500) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const openMenu = () => {
    setShowMenu(true);
  };

  const closeMenu = () => {
    setTimeout(() => {
      setShowMenu(false);
    }, 50);
  };

  const goToExploreVenue = () => {
    router.push("/sports-venues");
    setShowMenu(false);
  };
  const goToExploreGames = () => {
    router.push("/games");
    setShowMenu(false);
  };
  const goToHome = () => {
    router.push("/");
    setShowMenu(false);
  };

  const handleDownload = () => {
    setShowMenu(false);

    if (isAndroid) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.turftown&hl=en_US";
    } else if (isIOS) {
      window.location.href = "https://onelink.to/turftown";
    } else {
      // setModal(true)
      window.location.href = "https://turftown.in";
    }
  };

  const homePageRoute = () => {
    router.push("/");
  };

  const exploreGamesRoute = () => {
    if (router.pathname == "/games") router.reload();
    router.push("/games");
  };

  const handleLogoutModal = useCallback(() => {
    setShowMenu(false);
    setModal("logout");
  }, []);

  const logout = useCallback(() => {
    setModal("");
    // actions?.logout();
    handlelogout();
  }, []);

  const containerVariants = {
    hidden: {
      opacity: 0,
      // zIndex: -10000,
    },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
      // zIndex: 10000,
    },
    exit: { opacity: 0, transition: { duration: 0.15 } }, // Exit animation
  };

  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20,
      // zIndex: -10000,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
    exit: { opacity: 0, y: -10, transition: { duration: 0.2 } }, // Items fade out
  };

  const dropdownVariants = {
    hidden: { y: -70, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", damping: 34, stiffness: 230, mass: 2 },
    },
  };

  return (
    <>
      <motion.div
        initial={noAnimation ? "hidden" : "hidden"}
        animate="visible"
        variants={dropdownVariants}
      >
        <nav className={classNames(styles.nav_desktop_container)}>
          <Image
            src={Logo2}
            alt="desktoplogo"
            className={classNames(styles.nav_desktop_logo)}
            onClick={homePageRoute}
          />
          <div className={styles.navbar_subDirectory}>
            {!minimal && (
              <div className={styles.subTitles}>
                <Item title={"Games"} url={"/games"} />
                <Item title={"Venues"} url={"/sports-venues"} />
                {/* <Item title={"Blog"} url={"/blog"} /> */}
                {user ? (
                  <LoggedInNavItem onClickLogout={handleLogoutModal} />
                ) : (
                  <Item
                    title={"Login"}
                    url={"/Login"}
                    link={false}
                    onClick={() => {
                      //   actions?.setLoginModalVisibility(true);
                      setLoginModalVisibility(true);
                    }}
                  />
                )}
              </div>
            )}

            {!user && (
              <div
                className={classNames(styles["download-button"])}
                onClick={() => setModal("download")}
              >
                <p
                  className={classNames(
                    styles["title_7"],
                    styles["white1"],
                    styles["font18"]
                  )}
                >
                  Download
                </p>
                <Image
                  height={20}
                  width={20}
                  src={"/icons/arrow-right-small.svg"}
                  alt="arrow icon"
                />
              </div>
            )}
          </div>
        </nav>
      </motion.div>
      <motion.div
        className={classNames(
          styles["navbar_container"],
          isScrolled && styles["fixed"]
        )}
      >
        {leftComponent ? leftComponent : <Logo />}
        {user ? (
          <LoggedInNavItem
            onClickLogout={handleLogoutModal}
            noDropdown
            onClick={openMenu}
          />
        ) : (
          <Image
            src={"/icons/menu_icon.png"}
            alt="menuIcon"
            height={20}
            width={22}
            className={classNames(
              styles["cursor-pointer"],
              styles.menuIcon_bar
            )}
            onClick={openMenu}
          />
        )}
      </motion.div>
      <AnimatePresence exitBeforeEnter>
        {showMenu && (
          <motion.div
            initial="hidden"
            animate="visible"
            variants={containerVariants}
            exit="exit"
            className={styles.menuModal}
          >
            <div className={styles.menuBar_right}>
              <Logo />
              <Image
                src={"/icons/common/close-icon.svg"}
                alt="close"
                onClick={closeMenu}
                height={18}
                width={18}
                className={classNames(
                  styles.close_icon,
                  styles["cursor-pointer"],
                  user && styles["logged_in"]
                )}
              />
            </div>
            <div className={styles.menuBar_left}>
              <motion.div
                className={classNames(
                  styles.menuList,
                  !user && styles["mt-20"]
                )}
                variants={containerVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
              >
                {!minimal && (
                  <>
                    {user && (
                      <motion.div variants={itemVariants}>
                        <div
                          className={classNames(
                            styles["row"],
                            styles["align-center"],
                            styles["cursor-pointer"]
                          )}
                        >
                          <div className={classNames(styles.round_image)}>
                            <Image
                              fill
                              src={
                                user?.profile_picture
                                  ? user?.profile_picture
                                  : "/images/empty_user_profile.webp"
                              }
                              style={{ objectFit: "cover" }}
                              alt="user image"
                            />
                          </div>
                          <p
                            className={classNames(
                              styles["deco-none"],
                              styles["nave_username"]
                            )}
                          >
                            {user.name}
                          </p>
                        </div>
                        <div
                          className={classNames(
                            styles["line"],
                            styles["mt-24"],
                            styles["mb-28"]
                          )}
                        />
                      </motion.div>
                    )}
                    <motion.div
                      onClick={handleDownload}
                      variants={itemVariants}
                      className={classNames(
                        styles["row"],
                        styles["align-center"],
                        styles["mt-8"]
                      )}
                    >
                      <p
                        className={classNames(
                          styles["mr-8"],
                          styles["nave_text"]
                        )}
                      >
                        Download
                      </p>
                      <Image
                        src={"/images/arrow.png"}
                        alt="get turftown"
                        height={14}
                        width={18}
                        onClick={handleDownload}
                        style={{ marginTop: 1 }}
                      />
                    </motion.div>
                    <motion.div
                      variants={itemVariants}
                      className={classNames(styles["mt-32"])}
                    >
                      <Link
                        href={"/"}
                        className={classNames(
                          styles["deco-none"],
                          styles["nave_text"]
                        )}
                        onClick={goToHome}
                      >
                        Home
                      </Link>
                    </motion.div>
                    <motion.div
                      variants={itemVariants}
                      className={classNames(styles["mt-32"])}
                    >
                      <Link
                        href={"/sports-venues"}
                        className={classNames(
                          styles["mt-32"],
                          styles["deco-none"],
                          styles["nave_text"]
                        )}
                        onClick={goToExploreVenue}
                      >
                        Venues
                      </Link>
                    </motion.div>
                    <motion.div
                      variants={itemVariants}
                      className={classNames(styles["mt-32"])}
                    >
                      <Link
                        href={"/games"}
                        className={classNames(
                          styles["mt-32"],
                          styles["deco-none"],
                          styles["nave_text"]
                        )}
                      >
                        Games
                      </Link>
                    </motion.div>
                    {/* <motion.div
                      variants={itemVariants}
                      className={classNames(styles["mt-32"])}
                    >
                      <Link
                        href={"/blog"}
                        className={classNames(
                          styles["mt-32"],
                          styles["deco-none"],
                          styles["nave_text"]
                        )}
                      >
                        Blog
                      </Link>
                    </motion.div> */}
                    {user && (
                      <motion.div
                        variants={itemVariants}
                        className={classNames(styles["mt-32"])}
                      >
                        <Link
                          href={"/your-games"}
                          className={classNames(
                            styles["mt-32"],
                            styles["deco-none"],
                            styles["nave_text"]
                          )}
                        >
                          Your Games
                        </Link>
                      </motion.div>
                    )}
                    {!user && (
                      <motion.div
                        variants={itemVariants}
                        className={classNames(styles["mt-32"])}
                      >
                        <p
                          onClick={() => {
                            // actions?.setLoginModalVisibility(true);
                            setLoginModalVisibility(true);
                            setShowMenu(false);
                          }}
                          className={classNames(
                            styles["deco-none"],
                            styles["nave_text"]
                          )}
                        >
                          Login
                        </p>
                      </motion.div>
                    )}
                    {user && (
                      <motion.div
                        variants={itemVariants}
                        className={classNames(styles["mt-32"])}
                      >
                        <p
                          onClick={handleLogoutModal}
                          className={classNames(
                            styles["deco-none"],
                            styles["nave_text"]
                          )}
                        >
                          Logout
                        </p>
                      </motion.div>
                    )}
                  </>
                )}
              </motion.div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <GetTurfTownModal
        show={showModal == "download"}
        onClose={() => {
          setModal("");
        }}
      />
      <Modal
        show={showModal == "logout"}
        onClose={() => {
          setModal("");
        }}
      >
        <div className={styles.modal}>
          <p className={classNames(styles.modalTitle, styles["mb-20"])}>
            Would you like to logout?
          </p>
          <div className={classNames(styles["mb-44"])} />
          <div className={styles["row"]}>
            <div className={styles.width_45}>
              <PrimaryButton
                buttonType={ButtonType.BORDER}
                text={"Cancel"}
                onPress={() => {
                  setModal("");
                }}
              />
            </div>
            <div className={styles.width_45}>
              <PrimaryButton
                buttonType={ButtonType.SECONDARY}
                text={"Logout"}
                onPress={logout}
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default NavBar;
